import { ELoanStatuses, FormattedLoanStatus, IFormattedLoan } from 'store/fetchers/loans/enum'

export const getFormattedLoanStatus = (loanStatus: ELoanStatuses): FormattedLoanStatus => {
  switch (loanStatus) {
    case ELoanStatuses.CONFIRMED:
      return FormattedLoanStatus.PENDING
    case ELoanStatuses.CANCELLED:
      return FormattedLoanStatus.CANCELED
    case ELoanStatuses.DEPOSIT_RECEIVED:
    case ELoanStatuses.TRANSACTION_SENT:
    case ELoanStatuses.PLEDGE_REDEEMED:
    case ELoanStatuses.PLEDGE_TRANSACTION_SENT:
    case ELoanStatuses.PLEDGE_SENT:
    case ELoanStatuses.LOAN_SUCCESS:
      return FormattedLoanStatus.PROCESSING
    case ELoanStatuses.ORDER_CREATED:
    case ELoanStatuses.LOAN_FAILED:
    case ELoanStatuses.FAILED_BY_PARTNER:
      return FormattedLoanStatus.ACTIVE
    case ELoanStatuses.CLOSED:
      return FormattedLoanStatus.CLOSED
    case ELoanStatuses.LIQUIDATED:
      return FormattedLoanStatus.LIQUIDATED
    default:
      return null
  }
}

export const getLoanCardColumns = (loan: IFormattedLoan): string[] => {
  if (!loan) {
    return ['Collateral', 'Date', 'Current rate', 'Margin call', 'Status', 'Health']
  }
  if (loan.status === ELoanStatuses.CLOSED || loan.status === ELoanStatuses.LIQUIDATED || loan.current_zone === null) {
    return ['Collateral', 'Date', 'Current rate', 'Margin call', 'Status']
  }
  return ['Collateral', 'Date', 'Current rate', 'Margin call', 'Status', 'Health']
}
